import { useCallback } from 'react';

import type { Match } from '@/core/schemas';
import { activeTournamentId } from '@/features/tournament/useTournament';
import { subscribeMatches } from '@/infrastructure/repositories/matchRepository';
import { useLiveData, type LiveData } from '@/shared/hooks/useLiveData';

/**
 * Every match of the tournament, live.
 *
 * Schedule, groups, bracket and "next match" are all derived from this one
 * array — no view opens its own listener, and no derived value is stored.
 */
export function useMatches(): LiveData<Match[]> {
  const subscribe = useCallback(
    (onData: (value: Match[]) => void, onError: Parameters<typeof subscribeMatches>[2]) =>
      subscribeMatches(activeTournamentId, onData, onError),
    [],
  );

  return useLiveData<Match[]>(['matches', activeTournamentId], subscribe);
}
